import React from 'react';
import Img from './Img';
import { affiliations, partnerLogos } from '../mock';

export default function Affiliations() {
  return (
    <section className="bg-white py-12 border-b border-[#ECEEF1]">
      <div className="container-x">
        <div className="text-[10.5px] tracking-[0.22em] uppercase text-[#546072] text-center mb-7">
          In partnership with
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14 mb-10">
          {partnerLogos.map((p) => (
            <a
              key={p.name}
              href={p.href}
              target="_blank"
              rel="noreferrer"
              title={p.name}
              className="inline-flex items-center justify-center opacity-80 hover:opacity-100 transition-opacity"
              style={{ minHeight: 60 }}
            >
              <Img
                src={p.src}
                alt={p.name}
                height={p.height || 56}
                style={{
                  height: `${p.height || 56}px`,
                  width: 'auto',
                  maxWidth: 240,
                  objectFit: 'contain',
                  filter: p.invert ? 'invert(1) brightness(0.15)' : 'none',
                }}
              />
            </a>
          ))}
        </div>

        <div className="pt-8 border-t border-[#ECEEF1]">
          <div className="text-[10.5px] tracking-[0.22em] uppercase text-[#546072] text-center mb-4">
            Affiliated with
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-1 text-[13px] text-[#232830]">
            {affiliations.map((a, i) => (
              <span key={a} className="whitespace-nowrap">
                {a}{i < affiliations.length - 1 && <span className="text-[#B5BDC8] mx-2">·</span>}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
